// Tilts its first child toward the cursor in 3D. Fine pointers only; off with reduced motion.
class KTilt extends HTMLElement {
  connectedCallback() {
    const fine = matchMedia('(hover: hover) and (pointer: fine)').matches;
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!fine || reduce) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    const max = Number(this.getAttribute('max') || 8);
    this.style.perspective = '1000px';
    let frame = 0;
    this.addEventListener('pointermove', (event) => {
      const target = this.firstElementChild;
      if (!target) return;
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const rect = this.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        target.style.transition = 'transform 120ms cubic-bezier(0.16, 1, 0.3, 1)';
        target.style.transform = `rotateX(${(-y * max).toFixed(2)}deg) rotateY(${(x * max).toFixed(2)}deg) translateZ(0)`;
        target.style.setProperty('--glare-x', `${((x + 0.5) * 100).toFixed(1)}%`);
        target.style.setProperty('--glare-y', `${((y + 0.5) * 100).toFixed(1)}%`);
      });
    }, { signal });
    this.addEventListener('pointerleave', () => {
      const target = this.firstElementChild;
      if (!target) return;
      cancelAnimationFrame(frame);
      target.style.transition = 'transform 500ms cubic-bezier(0.16, 1, 0.3, 1)';
      target.style.transform = '';
    }, { signal });
  }

  disconnectedCallback() {
    this.controller?.abort();
  }
}

if (!customElements.get('k-tilt')) customElements.define('k-tilt', KTilt);
